import React, {Component} from 'react';

import MainContent from "./MainContent";

class MainPanel extends Component{

    constructor(props) {
        super(props);
        this.props=props;
    }


    render() {
        return (
            <React.Fragment>
                <div className="main-panel " ref={this.mainPanel} >
                    <MainContent />
                </div>
            </React.Fragment>
        );
    }
}

export default MainPanel;
